import {Routes, Route} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Home from './components/Home';
import MenuWithMotionEnhanced from './components/MenuWithMotionEnhanced';
import Schedule from './components/Schedule';
import Passport from './components/Passport';
import ToonieTaste from './components/ToonieTaste';

const App = () => (
  <HelmetProvider>
    <Routes>
      <Route path="/" element={<><Navbar /><Home /></>} />
      <Route path="/schedule" element={<Schedule />} />
      <Route path="/passports" element={<Passport />} />
      <Route path="/toonie-taste" element={<ToonieTaste />} />
      <Route path="/menu" element={<MenuWithMotionEnhanced />} />
    </Routes>
  </HelmetProvider>
);

export default App;
